<template>
    <!-- we can use $attrs to pass through v-tooltip props
               v-bind="$attrs"
               :color="$attrs.color||'primary'"
        to invert the icon use
               :invert="true"
    -->
    <v-tooltip :z-index="10001"
               v-bind="$attrs"
               bottom
               color="white"
               class="handcursor dmb--tooltip"
               :close-delay="delayClose"
               :content-class="tooltipWidth">
      <template v-slot:activator="{on}">
        <v-icon :color="(invert) ? 'white' : 'primary'"
                :class="disabled ? 'disabled': ''"
                v-on="on">
          {{ icon }}
        </v-icon>
      </template>
        <h2 v-if="titel" class="dmbtooltiptitle secondary--text" >{{ titel }}</h2>
        <div class="secondary--text font-weight-medium"><slot/></div>
    </v-tooltip>
</template>
<script>
export default {
  name: "SiteTooltip",
  props: {
    titel: {
      type: String,
      default: ""
    },
    invert: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'info'
    }
  },
  computed:{
    delayClose(){
      return this.$attrs && this.$attrs["close-delay"] ? this.$attrs["close-delay"] : 1000;
    },
    tooltipWidth(){
      return this.$attrs && this.$attrs["content-class"] ? this.$attrs["content-class"] : "dmbtooltip";
    }
  }
};
</script>
<style>
  a {
    /*get rid of UpperCase Buttons*/
    text-decoration: none !important;
  }
  .dmb--tooltip .disabled {
    color: rgba(0, 0, 0, 0.54) !important;
  }
  .dmbtooltip {
    /*width: 45rem !important;*/
    width: auto;
    max-width: 30% !important;
    opacity: 1.0  !important;
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
  }
  .dmbwidetooltip {
    width: auto;
    max-width: 100% !important;
    opacity: 1.0  !important;
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
  }
  .dmbtooltiptitle{
    /*width: 45rem !important;*/
    width: auto;
    opacity: 1.0  !important;
  }
  .dmbtooltip ul {
    list-style: inside;
    padding: 0!important;
  }
  .dmbtooltip li {
    white-space: nowrap;
  }
</style>
